export type TranslatableField = Record<string, string>;

// commented out languages exist in surveys but not engage
export enum SupportedLanguages {
  ARABIC = 'ar',
  ARMENIAN = 'hy',
  BENGALI = 'bn',
  // CABO_VERDEAN_CREOLE = 'cpp',
  ENGLISH = 'en',
  SPANISH = 'es',
  FRENCH = 'fr',
  PERSIAN = 'fa',
  HINDI = 'hi',
  HMONG = 'hmn',
  HAITIAN_CREOLE = 'ht',
  JAPANESE = 'ja',
  KHMER = 'km',
  KOREAN = 'ko',
  // LAO = 'lo',
  NEPALI = 'ne',
  PUNJABI = 'pa',
  POLISH = 'pl',
  PORTUGUESE = 'pt',
  RUSSIAN = 'ru',
  TAGALOG = 'tl',
  VIETNAMESE = 'vi',
  PASHTO = 'ps',
  BURMESE = 'my',
  YORUBA = 'yo',
  AMHARIC = 'am',
  SOMALI = 'so',
  SWAHILI = 'sw',
  // KINYARWANDA = 'rw',
  OROMO = 'om',
  URDU = 'ur',
  // TELUGU = 'te',
  TURKISH = 'tr',
  // CHINESE = 'zh',
  // TRADITIONAL_CHINESE = 'zho',
  TAMIL = 'ta',
  // CANTONESE = 'yue',
  // TIGRINYA = 'ti',
  UKRAINIAN = 'uk',
  GERMAN = 'de',
  GREEK = 'el',
  GUJARATI = 'gu',
  HEBREW = 'he',
  ITALIAN = 'it',
  DUTCH = 'nl',
  ROMANIAN = 'ro',
  THAI = 'th',
  YIDDISH = 'yi',
  CHINESE_SIMPLIFIED = 'zh-CN',
  CHINESE_TRADITIONAL = 'zh-TW',

  // codes added with new builder
  AMHARIC_ETHIOPIA = 'am-ET',
  ARABIC_UAE = 'ar-AE',
  ARABIC_SAUDI_ARABIA = 'ar-SA',
  BULGARIAN_BULGARIA = 'bg-BG',
  BENGALI_BANGLADESH = 'bn-BD',
  BOSNIAN_BOSNIA_HERZEGOVINA = 'bs-BA',
  CZECH_CZECH_REPUBLIC = 'cs-CZ',
  WELSH_UK = 'cy-GB',
  DANISH_DENMARK = 'da-DK',
  GERMAN_AUSTRIA = 'de-AT',
  GERMAN_SWITZERLAND = 'de-CH',
  GERMAN_GERMANY = 'de-DE',
  GREEK_GREECE = 'el-GR',
  ENGLISH_AUSTRALIA = 'en-AU',
  ENGLISH_CANADA = 'en-CA',
  ENGLISH_UK = 'en-GB',
  ENGLISH_IRELAND = 'en-IE',
  ENGLISH_NEW_ZEALAND = 'en-NZ',
  ENGLISH_US = 'en-US',
  SPANISH_ARGENTINA = 'es-AR',
  SPANISH_COLOMBIA = 'es-CO',
  SPANISH_SPAIN = 'es-ES',
  SPANISH_MEXICO = 'es-MX',
  SPANISH_US = 'es-US',
  ESTONIAN_ESTONIA = 'et-EE',
  PERSIAN_IRAN = 'fa-IR',
  FINNISH_FINLAND = 'fi-FI',
  FRENCH_CANADA = 'fr-CA',
  FRENCH_FRANCE = 'fr-FR',
  IRISH_IRELAND = 'ga-IE',
  GUJARATI_INDIA = 'gu-IN',
  HEBREW_ISRAEL = 'he-IL',
  HINDI_INDIA = 'hi-IN',
  // HMN
  CROATIAN_CROATIA = 'hr-HR',
  HATIAN_CREOLE_HAITI = 'ht-HT',
  HUNGARIAN_HUNGARY = 'hu-HU',
  ARMENIAN_ARMENIA = 'hy-AM',
  INDONESIAN_INDONESIA = 'id-ID',
  ICELANDIC_ICELAND = 'is-IS',
  ITALIAN_ITALY = 'it-IT',
  JAPANESE_JAPAN = 'ja-JP',
  GEORGIAN_GEORGIA = 'ka-GE',
  KHMER_CAMBODIA = 'km-KH',
  KOREAN_SOUTH_KOREA = 'ko-KR',
  LITHUANIAN_LITHUANIA = 'lt-LT',
  LATVIAN_LATVIA = 'lv-LV',
  MALAY_MALAYSIA = 'ms-MY',
  MALTESE_MALTA = 'mt-MT',
  BURMESE_MYANMAR = 'my-MM',
  DUTCH_BELGIUM = 'nl-BE',
  DUTCH_NETHERLANDS = 'nl-NL',
  NORWEGIAN_NORWAY = 'no-NO',
  PUNJABI_INDIA = 'pa-IN',
  POLISH_POLAND = 'pl-PL',
  PASHTO_AFGHANISTAN = 'ps-AF',
  PORTUGUESE_BRAZIL = 'pt-BR',
  PORTUGUESE_PORTUGAL = 'pt-PT',
  NEPALI_NEPAL = 'ne-NP',
  ROMANIAN_ROMANIA = 'ro-RO',
  RUSSIAN_RUSSIA = 'ru-RU',
  SLOVAK_SLOVAKIA = 'sk-SK',
  SLOVENIAN_SLOVENIA = 'sl-SI',
  SOMALI_SOMALIA = 'so-SO',
  ALBANIAN_ALBANIA = 'sq-AL',
  SERBIAN_SERBIA = 'sr-RS',
  SWEDISH_SWEDEN = 'sv-SE',
  SWAHILI_KENYA = 'sw-KE',
  TAMIL_INDIA = 'ta-IN',
  THAI_THAILAND = 'th-TH',
  TAGALOG_PHILIPPINES = 'tl-PH',
  TURKISH_TURKEY = 'tr-TR',
  UKRAINIAN_UKRAINE = 'uk-UA',
  URDU_PAKISTAN = 'ur-PK',
  VIETNAMESE_VIETNAM = 'vi-VN',
  YORUBA_NG = 'yo-NG',
  YORUBA_BJ = 'yo-BJ',
  // YIDDISH
  // CHINESE CHINA
  CHINESE_HONG_KONG = 'zh-HK',
  // CHINESE TAIWAN
  CHUUKEESE = 'chk',
}
